module.exports = __webpack_public_path__ + "img/silver3.0c3c5665.png";